import Button from "../../components/Button"
// import {ICatGridFilter, ICatGridQuery} from '../../helpers/Interfaces'

// interface HomeProps {
//     filterObj: ICatGridFilter;
//     setFilterObj: Function;
//     queryObj: ICatGridQuery;
//     setQueryObj: Function;
// }

export default function ProdsFilterBlock(props: any) {

    const {filterObj, setFilterObj, queryObj, setQueryObj} = props

    function handleChange(value: string, name: string) {
        setFilterObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }

    function handleClick(event: any) {
        window.history.replaceState(null, '', `../prods/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })

            localStorage.setItem('filterProds', JSON.stringify(filterObj))

        } else {
            for (let k in filterObj) {
                filterObj[k as keyof typeof filterObj] = ''
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })

            localStorage.removeItem("filterProds")
            // localStorage.setItem('filterFields', JSON.stringify({}));
        }
    }

    return (

        <div className="filter-base-container prods-grid-filter">

            <div className="prod-filter-items">

                <div className="prods-filter-oneblock">
                    <div className="field-label">Brand</div>
                    <input
                        name="brand"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.brand}
                    />
                </div>

                <div className="prods-filter-oneblock">
                    <div className="field-label">MPN</div>
                    <input
                        name="mpn"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.mpn}
                    />
                </div>

                <div className="prods-filter-oneblock">
                    <div className="field-label">EAN</div>
                    <input
                        name="ean"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.ean}
                    />
                </div>

                <div className="prods-filter-oneblock">
                    <div className="field-label">Cat&nbsp;name</div>
                    <input
                        name="catName"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.catName}
                    />
                </div>

                <div className="prods-filter-oneblock">
                    <div className="field-label">Cat&nbsp;ID</div>
                    <input
                        name="catID"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.catID}
                    />
                </div>


            </div>


            <div className="prod-filter-buttons">
                <div className="btn-container">
                    {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                    <Button type="primary" text="Search" onclick={(event: any) => handleClick(event)}/>
                </div>

                <div className="btn-container">
                    <Button type="secondary" text="Clear" onclick={(event: any) => handleClick(event)}/>
                </div>
            </div>

        </div>

    )
}
